var map = {
	"./BBSRC.png": "e3fc",
	"./NIH.png": "48ea",
	"./VB_logo_black.svg": "fff1",
	"./VectorByte-logo-4k.png": "ed41",
	"./VectorByte-logo-alt.svg": "7dcd",
	"./vecdyn_logo.svg": "abb1",
	"./vectrait_logo.svg": "672e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8c6";